import React from "react";

const TiktokIconNew = ({
  width = 24,
  height = 24,
  fill = "white",
  className,
}: {
  fill?: string;
  className?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2078_63456)">
        <path
          d="M17.0725 0.000732422H13.0278V16.3485C13.0278 18.2964 11.4722 19.8964 9.53626 19.8964C7.60034 19.8964 6.04469 18.2964 6.04469 16.3485C6.04469 14.4355 7.56577 12.8703 9.43257 12.8007V8.6964C5.31872 8.76593 2 12.1399 2 16.3485C2 20.5921 5.38786 24.0007 9.57085 24.0007C13.7538 24.0007 17.1416 20.5573 17.1416 16.3485V7.96593C18.6627 9.079 20.5295 9.73987 22.5 9.77467V5.6703C19.4579 5.56595 17.0725 3.0616 17.0725 0.000732422Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2078_63456">
          <rect width="24" height="24" fill={fill} transform="translate(0 0.000732422)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TiktokIconNew;
